import OETrans from 'components/translation/OETrans';
import React from 'react';

const CounterComponent = ({ answeredNumber, toAnswerNumber }) => {
  const counters = [
    { number: answeredNumber, translationText: <OETrans code='ICS146' /> },
    {
      number: toAnswerNumber,
      translationText: (
        <>
          {answeredNumber === 1 ? <OETrans code='ICS148' /> : <OETrans code='ICS147' />}{' '}
          <OETrans code='ICS149' />
        </>
      ),
    },
  ];

  return (
    <div className='d-flex align-items-center'>
      {counters.map(({ number, translationText }, index) => (
        <React.Fragment key={index}>
          <span>{translationText}</span>
          <div className='counter-answers-wrapper mx-1 d-flex justify-content-center'>
            <p>{number}</p>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default CounterComponent;
